import {
  useApproval,
  type ApprovalActionStatus,
} from '@/components/shared/requisitions/hooks/useApproval';

export type { ApprovalActionStatus };

interface UseRequisitionApprovalProps {
  requisitionId?: number | string | null;
  requisitionIds?: number[] | string[] | null;
  onSuccess?: () => void;
}

interface UseRequisitionApprovalReturn {
  actionStatus: ApprovalActionStatus;
  isApproveActionLoading: boolean;
  rejectModalActions: {
    isOpen: boolean;
    onOpen: () => void;
    onClose: () => void;
    onToggle: () => void;
    isControlled: boolean;
    getButtonProps: (props?: any) => any;
    getDisclosureProps: (props?: any) => any;
  };
  rejectApproveFields: Array<{
    name: string;
    type: string;
    label: string;
    placeholder: string;
  }>;
  handleApprove: () => void;
  handleReject: () => void;
  handleRejectSubmit: (values?: { note?: string }) => void;
}

export const useRequisitionApproval = ({
  requisitionId,
  requisitionIds,
  onSuccess,
}: UseRequisitionApprovalProps): UseRequisitionApprovalReturn => {
  return useApproval({
    entityId: requisitionId,
    entityIds: requisitionIds,
    type: 'requisition',
    onSuccess,
  });
};
